import { TableStatus } from "../types/TableStatuses";
import { ExtractedRow, ExtractedRowData } from "./ExtractedRow";
import { TableModel, TableModelData } from "./TableModel";

type ExtractedTableDataDto = {
  name: string;
  rows: ExtractedRowData[];
  status: TableStatus;
  tableTemplateData: TableModelData;
};
class ExtractedTable {
  name: string;
  rows: ExtractedRow[];
  status: TableStatus;
  tableModelId: string;
  tableTemplateData: TableModelData;
  private _hasOcrWarning: boolean = false;
  private _hasCellInvalid: boolean = false;

  constructor(data: ExtractedTableDataDto) {
    this.name = data.name;
    this.rows = data.rows.map((row) => new ExtractedRow(row));
    this.rows.sort((a, b) => a.rowNumber - b.rowNumber);
    this._hasOcrWarning =
      this.rows.flatMap((x) => x.cells).filter((x) => x.hasOcrWarning).length >
      0;
    this._hasCellInvalid =
      this.rows.flatMap((x) => x.cells).filter((x) => !x.valid).length > 0;
    this.status = data.status;
    this.tableTemplateData = data.tableTemplateData;
    this.tableModelId = new TableModel(this.tableTemplateData).getModelId();
  }

  get hasCellInvalid(): boolean {
    return this._hasCellInvalid;
  }
  get hasOcrWarning(): boolean {
    return this._hasOcrWarning;
  }
  set hasOcrWarning(value: boolean) {
    this._hasOcrWarning = value;
  }
  extractedBy(tableModel: TableModel): boolean {
    return this.tableModelId === tableModel.getModelId();
  }

  static createTest(rest: Partial<ExtractedTableDataDto> = {}): ExtractedTable {
    const data: ExtractedTableDataDto = {
      name: "",
      status: "MISSING",
      rows: [],
      tableTemplateData: TableModel.createTest().toTableModelData(),
    };

    return new ExtractedTable({
      ...data,
      ...rest,
    });
  }
}

export { ExtractedTable, ExtractedTableDataDto };
